import React from 'react';
import PropTypes from 'prop-types';
import {
  DialogBox as SparkDialogBox,
  ConfirmDialog as SparkConfirmDialog,
} from 'xm-spark';
import { portalPopover, portalPopoverLvl2 } from 'utils/appLayout';
import styles from './DialogBoxPortal.module.scss';

export default function DialogBoxPortal(props) {
  const portalFn = props.level2 ? portalPopoverLvl2 : portalPopover;
  return portalFn(
    <div className={styles.container}>
      <SparkDialogBox
        {...props}
        classes={{
          wrap: styles.wrap,
          ...props.classes,
        }}
      />
    </div>,
  );
}

DialogBoxPortal.displayName = 'DialogBoxPortal';
DialogBoxPortal.propTypes = {
  level2: PropTypes.bool,
};
DialogBoxPortal.defaultProps = {
  level2: false,
};

// Special case using confirm dialog:
export function ConfirmDialogPortal(props) {
  const portalFn = props.level2 ? portalPopoverLvl2 : portalPopover;
  return portalFn(
    <div className={styles.container}>
      <SparkConfirmDialog {...props} />
    </div>,
  );
}

ConfirmDialogPortal.displayName = 'ConfirmDialogPortal';
ConfirmDialogPortal.propTypes = {
  level2: PropTypes.bool,
};
ConfirmDialogPortal.defaultProps = {
  level2: false,
};
